
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material";
import { Questions } from "../classes/question";
import { MatDialogRef } from '@angular/material';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';
import { SecondLanguageService } from "../shared/services/second-language.service";
import * as XLSX from 'xlsx';
import { Cascad } from "../classes/Cascad";
import { isUndefined } from "util";
import { CascadingJSONService } from "../shared/services/cascading-json.service";
import {RestApiService} from "../shared/restApiServices/restapi.service"


type AOA = Array<Array<any>>;

function s2ab(s: string): ArrayBuffer {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  };
  return buf;
}

@Component({
  selector: 'edit-question-dialog',
  templateUrl: './edit-question-dialog.component.html',
  styleUrls: ['edit-question-dialog.component.css']
})
export class EditQuestionDialogComponent {

  numberQuestionLabel = "Only one answer will be collected.";
  calendarQuestionLabel = "Only month and year will be accepted.";
  numberSuggestionLabel = "Only numbers from 0 to +ve ∞ will be accepted.";
  shouldIShowMaximum: boolean;
  shouldIShowOptions: boolean;
  primaryQuestionPlaceholder: string;
  secondaryQuestionPlaceholder: string;
  partitionText= "Answer preferences";
  primaryQuestionValue: string;
  secondaryQuestionValue: string;
  maximumLabel: string = "";
  charLimitLable = "Set characters limit";
  maxPlaceholder = 500;
  maximumValue: string = "";
  maximumDefault: string = "";
  requiredImage: string = "";
  primaryLanguageQuestionEmpty = "";
  secondaryLanguageQuestionEmpty = "";
  optionsSort: Array<OptionsSort> = [];
  noConditionSelected: string = "";
  sucessCascad: boolean = false;
  // final

  fileName: string = "";

  numberOptions: Array<NumberOptions> = [{
    label: "Whole Number",
    img: '../../assets/images/radio_button_unchecked.svg'
  }, {
    label: "Mobile Number",
    img: '../../assets/images/radio_button_unchecked.svg'
  }, {
    label: "Decimal Number",
    img: '../../assets/images/radio_button_unchecked.svg'
  }, {
    label: "Natural Number",
    img: '../../assets/images/radio_button_unchecked.svg'
  }];
  calendarTypes: Array<CalendarTypes> = [
    {
      label: 'Month & Year',
      img: '../../assets/images/radio_button_unchecked.svg'
    }, {
      label: 'Date, Month & Year',
      img: '../../assets/images/radio_button_unchecked.svg'
    }
  ];

  question: Questions;
  parentQuestion: Questions;

  languages: string[];

  heading:string;
  subHeading: string;



  isEdit = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data : any, public dialogRef: MatDialogRef<EditQuestionDialogComponent>,private toastyService:ToastyService, private toastyConfig: ToastyConfig, private secondLanguageService : SecondLanguageService, private cascadJSONService : CascadingJSONService, private restApiService:RestApiService){
    this.question = JSON.parse(JSON.stringify(data.question));
    this.parentQuestion = data.parentQuestion;
    this.languages = this.secondLanguageService.getLanguages();


    if (this.question.Qn.length > 0) {
      this.isEdit = true;
      this.primaryQuestionValue = this.question.Qn;
    } else {
      this.primaryQuestionValue = "";
    }
    if (this.question.S_Qn.length > 0) {
      this.secondaryQuestionValue = this.question.S_Qn;
    } else {
      this.secondaryQuestionValue = "";
    }

    if (this.question.Is_Mandt) {
      this.requiredImage = "../../assets/images/check_box_checked.svg";
    } else {
      this.requiredImage = "../../assets/images/check_box_unchecked.svg";
    }

    switch (this.question.Qn_Disp_Value) {
      case ('Short Text'): {
        this.partitionText= "Answer preferences";
        this.heading= "Question for a short answer";
        this.subHeading= "Write your question below and create to get a short answer as a response.";
        this.shouldIShowMaximum = true;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "What is your name?";
        this.secondaryQuestionPlaceholder = "आपका क्या नाम है?";
        this.maximumLabel = "Max characters:";
        this.maximumDefault = "Answer characters will be limited to 500.";
        this.maxPlaceholder = 500;
        this.maximumValue = '500';
        if (this.question.Max_Char != 500) {
          this.maximumValue = this.question.Max_Char.toString();
        }
        break;
      }
      case ('Long Text'): {
        this.partitionText= "Answer preferences";
        this.heading= "Question for a long answer";
        this.subHeading= "Write your question below and create to get a long answer as a response.";
        this.shouldIShowMaximum = true;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "What is your address?";
        this.secondaryQuestionPlaceholder = "आपका पता क्या है?";
        this.maximumLabel = "Max characters:";
        this.maximumDefault = "Default limit is 500 characters";
        this.maxPlaceholder = 500;
        this.maximumValue = '500';
        if (this.question.Max_Char != 500) {
          this.maximumValue = this.question.Max_Char.toString();
        }
        break;
      }
      case ('Number'): {
        this.partitionText= "Answer preferences";
        this.heading= "Question for a numerical answer";
        this.subHeading= "Write your question below and create to get a number as a response.";
        if (this.question.Qn_Type.charAt(0) !== 'M')
          this.shouldIShowMaximum = true;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "How many family members are there in your family?";
        this.secondaryQuestionPlaceholder = "आपके परिवार में कितने सदस्य हैं?";
        this.maximumLabel = "Max characters:";
        this.maximumDefault = "Answer characters will be limited to 10.";
        this.maxPlaceholder = 10;
        this.maximumValue = '10';
        if (this.question.Max_Char != 500) {
          this.maximumValue = this.question.Max_Char.toString();
        }
        if (this.question.Qn_Type.charAt(0) === 'W') {
          this.numberOptions[0].img = "../../assets/images/radio_button_checked.svg";
        } else if (this.question.Qn_Type.charAt(0) === 'M') {
          this.numberOptions[1].img = "../../assets/images/radio_button_checked.svg";
        } else if (this.question.Qn_Type.charAt(0) === 'D') {
          this.numberOptions[2].img = "../../assets/images/radio_button_checked.svg";
        } else {
          this.numberOptions[3].img = "../../assets/images/radio_button_checked.svg";
        }
        break;
      }
      case ('Single Choice'): {
        this.partitionText= "Options";
        this.heading= "Question for a single choice answer";
        this.subHeading= "Write your question below and create to get single choice as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = true;
        this.primaryQuestionPlaceholder = "Is this your permanent address?";
        this.secondaryQuestionPlaceholder = "क्या यह आपका स्थायी पता है?";
        if (this.question.Opt_Name.length > 0) {

          for (let i = 0; i < this.question.Opt_Name.length; i = i + 1) {
            this.optionsSort.push({
              primaryLanguage: this.question.Opt_Name[i],
              primaryLanguagePlaceholder: "Primary Statement",
              primaryLanguageEmpty: "",
              secondaryLanguage: this.question.S_Opt_Name[i],
              secondaryLanguagePlaceholder: "Secondary Statement",
              secondaryLanguageEmpty: ""
            });
          }
        } else {
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "Yes",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "हाँ",
            secondaryLanguageEmpty: ""
          });
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "No",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "नहीं",
            secondaryLanguageEmpty: ""
          });
        }
        break;
      }
      case ('Multiple Choice'): {
        this.partitionText= "Options";
        this.heading= "Question for a multiple choice answer";
        this.subHeading= "Write your question below and create to get multiple choices as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = true;
        this.primaryQuestionPlaceholder = "Pick the items you own?";
        this.secondaryQuestionPlaceholder = "अपनी चीज़ों को चुनें?";
        if (this.question.Opt_Name.length > 0) {

          for (let i = 0; i < this.question.Opt_Name.length; i = i + 1) {
            this.optionsSort.push({
              primaryLanguage: this.question.Opt_Name[i],
              primaryLanguagePlaceholder: "Primary Statement",
              primaryLanguageEmpty: "",
              secondaryLanguage: this.question.S_Opt_Name[i],
              secondaryLanguagePlaceholder: "Secondary Statement",
              secondaryLanguageEmpty: ""
            });
          }
        } else {
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "Car",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "गाड़ी",
            secondaryLanguageEmpty: ""
          });
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "Bike",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "बाइक",
            secondaryLanguageEmpty: ""
          });
        }
        break;
      }
      case ('Dropdown'): {
        this.partitionText= "Options";
        this.heading= "Dropdown question";
        this.subHeading= "Write your question below and create to get one answer as a response in a dropdown format.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = true;
        this.primaryQuestionPlaceholder = "Select your state?";
        this.secondaryQuestionPlaceholder = "अपना राज्य चुनें?";
        if (this.question.Opt_Name.length > 0) {

          for (let i = 0; i < this.question.Opt_Name.length; i = i + 1) {
            this.optionsSort.push({
              primaryLanguage: this.question.Opt_Name[i],
              primaryLanguagePlaceholder: "Primary Statement",
              primaryLanguageEmpty: "",
              secondaryLanguage: this.question.S_Opt_Name[i],
              secondaryLanguagePlaceholder: "Secondary Statement",
              secondaryLanguageEmpty: ""
            });
          }
        } else {
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "Assam",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "असम",
            secondaryLanguageEmpty: ""
          });
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "Delhi",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "दिल्ली",
            secondaryLanguageEmpty: ""
          });
        }
        break;
      }
      case ('Calendar'): {
        this.partitionText= "Answer preferences";
        this.heading= "Question to pick a date in calendar";
        this.subHeading= "Write your question below and create to get a date as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Your birth date?";
        this.secondaryQuestionPlaceholder = "आपकी जन्म तिथि?";
        if (this.question.Qn_Type === "Calendar") {
          this.calendarTypes[0].img = "../../assets/images/radio_button_checked.svg";
        } else {
          this.calendarTypes[1].img = "../../assets/images/radio_button_checked.svg";
        }
        break;
      }
      case ('Location'): {
        this.heading= "Question to get location";
        this.subHeading= "Write your question below and create to get a location as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Location of house?";
        this.secondaryQuestionPlaceholder = "घर का स्थान?";
        break;
      }
      case ('Picture Input'): {
        this.heading= "Question to get picture";
        this.subHeading= "Write your question below and create to get a picture as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Picture?";
        this.secondaryQuestionPlaceholder = "चित्र?";
        break;
      }
      case ('Cascading Dropdown'): {
        this.partitionText= "Options";
        this.heading= "Cascading dropdown question";
        this.subHeading= "Write your question and upload the file below to get filtered answer form multiple dropdowns as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Name of Block/Panchayat/Habitation";
        this.secondaryQuestionPlaceholder = "ब्लॉक/पंचायत/गाँव का नाम?";
        break;
      }
      case('Rating'):{
        this.heading= "Question to get rating";
        this.subHeading= "Write your question below and create to get rating as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Rate the app";
        this.secondaryQuestionPlaceholder = "ब्लॉक/पंचायत/गाँव का नाम?";
        break;
      }
      case('Time'):{
        this.partitionText= "Answer preferences";
        this.heading= "Question to get time";
        this.subHeading= "Write your question below and create to get time as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Time of Survey";
        this.secondaryQuestionPlaceholder = "ब्लॉक/पंचायत/गाँव का नाम?";
        break;
      }
      case('Emoji'):{
        this.heading= "Question to get an emoji";
        this.subHeading= "Write your question below and create to get an emoji as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Your mood right now";
        this.secondaryQuestionPlaceholder = "ब्लॉक/पंचायत/गाँव का नाम?";
        break;
      }
      case('Range'):{
        this.heading= "Range Question";
        this.subHeading= "Write your range.";
        this.shouldIShowMaximum = true;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Range slider";
        this.secondaryQuestionPlaceholder = "ब्लॉक/पंचायत/गाँव का नाम?";
        this.maximumLabel = "Maximum characters";
        this.maximumDefault = "Default limit is 500 characters";
        if(this.question.Max_Char != 500){
          this.maximumValue = this.question.Max_Char.toString();
        }
        break;
      }
      case('Break'):{
        this.heading= "Section break";
        this.subHeading= "Write your section heading below to add.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Break Text";
        this.secondaryQuestionPlaceholder = "ब्लॉक/पंचायत/गाँव का नाम?";
        break;
      }
      case('Rank'):{
        this.partitionText= "Options";
        this.heading= "Question to rank your options";
        this.subHeading= "Write your question below and create to rank your options.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = true;
        this.primaryQuestionPlaceholder = "Set the priority list?";
        this.secondaryQuestionPlaceholder = "ु्ाबुराक्ाग पाहक्प ्पगहातोर?";
        if (this.question.Opt_Name.length > 0) {

          for (let i = 0; i < this.question.Opt_Name.length; i = i + 1) {
            this.optionsSort.push({
              primaryLanguage: this.question.Opt_Name[i],
              primaryLanguagePlaceholder: "Primary Statement",
              primaryLanguageEmpty: "",
              secondaryLanguage: this.question.S_Opt_Name[i],
              secondaryLanguagePlaceholder: "Secondary Statement",
              secondaryLanguageEmpty: ""
            });
          }
        } else {
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "1",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "1",
            secondaryLanguageEmpty: ""
          });
          this.optionsSort.push({
            primaryLanguage: "",
            primaryLanguagePlaceholder: "2",
            primaryLanguageEmpty: "",
            secondaryLanguage: "",
            secondaryLanguagePlaceholder: "2",
            secondaryLanguageEmpty: ""
          });
        }
        break;
      }
      case('Audio'):{
        this.heading= "Question to get audio";
        this.subHeading= "Write your question below and create to get an audio as a response.";
        // TODO : mahima set shouldIShowMaximum for time limit 
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Record your statement";
        this.secondaryQuestionPlaceholder = "अपनी बात रिकॉर्ड करें";
        this.maximumLabel = "Time Limit";
        this.maximumDefault = "Default limit is 5 minutes";
        if(this.question.Max_Char != 500){
          this.maximumValue = this.question.Max_Char.toString();
        }
        break;
      }
      case('Video'):{
        this.heading= "Question to get video";
        this.subHeading= "Write your question below and create to get a video as a response.";
        // TODO : mahima set shouldIShowMaximum for time limit 
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Record your video";
        this.secondaryQuestionPlaceholder = "अपना वीडियो रिकॉर्ड करें";
        this.maximumLabel = "Time Limit";
        this.maximumDefault = "Default limit is 5 minutes";
        if(this.question.Max_Char != 500){
          this.maximumValue = this.question.Max_Char.toString();
        }
        break;
      }
      case('Document'):{
        this.heading= "Question to get document";
        this.subHeading= "Write your question below and create to get a document as a response.";
        this.shouldIShowMaximum = false;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "Attach document";
        this.secondaryQuestionPlaceholder = "फाइल लगाए";
        // if(this.question.Max_Char != 500){
        //   this.maximumValue = this.question.Max_Char.toString();
        // }
        break;
      }
      case('Repeater_QT'): {
        this.partitionText= "Answer preferences";
        this.heading= "Repeater QT question ";
        this.subHeading= "Write your question below and create to get a small survey with in this survey as a response.";
        this.shouldIShowMaximum = true;
        this.shouldIShowOptions = false;
        this.primaryQuestionPlaceholder = "How many family members are there in your family?";
        this.secondaryQuestionPlaceholder = "आपके परिवार में कितने सदस्य हैं?";
        this.charLimitLable = "Set entries limit";
        this.maximumLabel = "Entry limit:";
        this.maximumDefault = "Entries will be limited to 10.";
        this.maxPlaceholder = 10;
        this.maximumValue = '10';
        if (this.question.Max_Char != 500) {
          this.maximumValue = this.question.Max_Char.toString();
        }
        break;
      }
    }
    this.toastyConfig.theme = 'bootstrap';
  }
  questionTypechanged(type: number) {
    switch (type) {
      case 0:
        this.question.Qn_Type = "Checkbox";
        this.question.Qn_Disp_Value= "Multiple Choice";
        break;
      case 1:
        this.question.Qn_Type = "Radio";
        this.question.Qn_Disp_Value="Single Choice";
        break;
      case 2:
        this.question.Qn_Type = "Selected Dropdown";
        this.question.Qn_Disp_Value= "Dropdown";
        break;
    }
  }

  showAnswerPreferences(){
    const qnType = this.question.Qn_Disp_Value;
    if(qnType == 'Document' || qnType == 'Video' || qnType == 'Audio' || qnType == 'Emoji' 
    || qnType == 'Rating' ||  qnType == 'Picture Input' || qnType == 'Location' 
    || qnType =='Break'){
      return false;
    }    
    return true;
  }

  primaryQuestionEntered(event: any) {
    this.question.Qn = event.target.value;
    this.primaryLanguageQuestionEmpty = "";
    console.log("primary Question Entered");
  }

  translateText(event: any, type){

    let text = event.target.value;
    if(text.length>1)
    {
        this.restApiService.translateText(text,this.languages[0],this.languages[1]).subscribe(
          result => {
            if(result.success)
            {
              if(type == 'primaryQues'){
                this.secondaryQuestionValue = result.data;
              }
              else if(typeof(type) == 'number'){
                this.optionsSort[type].secondaryLanguage = result.data;
              }
            }
          });
    }
  }

  secondaryQuestionEntered(event: any) {
    this.question.S_Qn = event.target.value;
    this.secondaryLanguageQuestionEmpty = "";
  }

  disabledForm(){
    if(!this.question.Qn || this.question.Qn.length == 0){
      return true;
    }
    if(this.languages[1].length > 0 && (!this.question.S_Qn || this.question.S_Qn.length == 0 )){
      return true;
    }
    return false;
  }


  maximumKeyPressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  maximumKeyup(event: any) {

    if (event.target.value.charAt(event.target.value.length - 1) === " ") {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
    }
  }

  maximumEntered(event : any){
    const maxValue= event.target.value.length >0 ?event.target.value:0;
    this.maximumValue = maxValue;
    if(this.question.Qn_Type == 'Repeater_QT'){
      if(event.target.value.length > 0)
      this.question.Max_Char = parseInt(event.target.value);
      this.maximumDefault =`Entries will be limited to ${maxValue}.`;
    }
    else if(this.question.Qn_Type === "Subjective" || this.question.Qn_Type === "TextArea"||this.question.Qn_Type== "Range"){
      if(event.target.value.length > 0)
      this.question.Max_Char = parseInt(event.target.value);
      this.maximumDefault =`Answer characters will be limited to ${maxValue}.`;
    }else{
      if(event.target.value > 0)
      this.question.Max_Char = parseInt(event.target.value);
      if(this.question.Qn_Type.charAt(0) === 'N'){
        if(event.target.value.length>0)
        this.question.Qn_Type = "NaturalNumMax"+event.target.value;
      }else if(this.question.Qn_Type.charAt(0) === 'W'){
        if(event.target.value.length>0)
        this.question.Qn_Type = "WholeNumMax"+event.target.value;
      }else{
        if(event.target.value.length>0)
        this.question.Qn_Type = "DecimalMax" + event.target.value;
      }
      this.maximumDefault =`Answer characters will be limited to ${maxValue}.`;
    }
  }

  numberOptionSelected(i: number) {
    if(this.disabledForm()){
      return;
    }
    for (let j = 0; j <= 3; j++) {
      this.numberOptions[j].img = "../../assets/images/radio_button_unchecked.svg";
    }
    this.numberOptions[i].img = "../../assets/images/radio_button_checked.svg";

    switch (i) {
      case 0: {
        this.numberSuggestionLabel = "Only numbers from 0 to +ve ∞ will be accepted.";
        this.shouldIShowMaximum = true;
        this.question.Qn_Type = "WholeNumMax" + this.question.Max_Char;
        break;
      }
      case 1: {
        this.numberSuggestionLabel = "Only numbers from 0 to +ve ∞ with length of 10 characters will be accepted.";
        this.shouldIShowMaximum = false;
        this.question.Qn_Type = "MobileNumMAX10";
        break;
      }
      case 2: {
        this.numberSuggestionLabel = "Numbers with decimal values will be accepted.";
        this.shouldIShowMaximum = true;
        this.question.Qn_Type = "DecimalMax" + this.question.Max_Char;
        break;
      }
      case 3: {
        this.numberSuggestionLabel = "Only numbers from 1 to +ve ∞ will be accepted.";
        this.shouldIShowMaximum = true;
        this.question.Qn_Type = "NaturalNumMax" + this.question.Max_Char;
        break;
      }
    }
  }


  calendarTypeSelected(i: number) {

    if(this.disabledForm()){
      return;
    }
    if (i == 0) {
      this.calendarQuestionLabel = "Only month and year will be accepted.";
      this.question.Qn_Type = "Calendar";
      this.calendarTypes[0].img = "../../assets/images/radio_button_checked.svg";
      this.calendarTypes[1].img = "../../assets/images/radio_button_unchecked.svg"
    } else {
      this.calendarQuestionLabel = "Date, month and year will be accepted.";
      this.question.Qn_Type = "CalendarWithDate";
      this.calendarTypes[0].img = "../../assets/images/radio_button_unchecked.svg";
      this.calendarTypes[1].img = "../../assets/images/radio_button_checked.svg"
    }

  }

  hasRangeOption(){
    if(this.question.Qn_Type == 'CalendarWithDate' ||  this.question.Qn_Type=='Time'){
      return true;
    }
    // this.question.Repeater - to make sure that range option is not available for questions in repeater form (backward compatibility)
    if(this.question.Qn_Disp_Value == 'Number' && this.question.Qn_Type.charAt(0) =='W' && !this.question.Repeater){
      return true;
    }
  }

  removeOption(i: number) {
    if(this.disabledForm()){
      return;
    }
    this.optionsSort.splice(i, 1);
  }

  addOption() {
    let hintText1 = `Enter your option in primary language here . . .`
    let hintText2 = `Enter your option in secondary language here . . .`
    if(this.optionsSort){
      hintText1 = `Enter your option ${this.optionsSort.length+1}`
      hintText2 = `Enter your option ${this.optionsSort.length+1}`
    }
    if(this.languages[1].length > 0){
      hintText1 = hintText1 + ' in primary language here . . .'
      hintText2 = hintText2 + '  in secondary language here . . .'
    }
    else{
      hintText1 = hintText1 + ' here . . .'
      hintText2 = hintText2 + ' here . . .'
    }
    this.optionsSort.push({
      primaryLanguage: "",
      primaryLanguagePlaceholder: hintText1,
      primaryLanguageEmpty: "",
      secondaryLanguage: "",
      secondaryLanguagePlaceholder: hintText2,
      secondaryLanguageEmpty: ""
    });
  }

  primaryOptionEntered($event: any, i: number) {
    this.optionsSort[i].primaryLanguage = $event.target.value;
    this.optionsSort[i].primaryLanguageEmpty = "";

  }

  secondaryOptionEntered($event: any, i: number) {
    this.optionsSort[i].secondaryLanguage = $event.target.value;
    this.optionsSort[i].secondaryLanguageEmpty = "";
  }



  required(require: boolean) {
    this.question.Is_Mandt = require;
    if (this.question.Is_Mandt) {
      this.requiredImage = "../../assets/images/check_box_checked.svg";
    } else {
      this.requiredImage = "../../assets/images/check_box_unchecked.svg";
    }
  }

  isRangeQuestion(isRange:boolean) {
    if(this.disabledForm()){
      return;
    }
    if(this.question.Is_Range == undefined){
      this.question.Is_Range = true;
      this.numberQuestionLabel= "Two answers with a min and max value will be collected";
    }
    else{
      this.question.Is_Range = isRange;
      if(isRange){
        this.numberQuestionLabel= "Two answers with a min and max value will be collected";
      }
      else{
        this.numberQuestionLabel = "Only one answer will be collected.";
      }
    }
  }

  save() {

    if (this.languages[1].length > 0) {

      if (!this.question.Qn || this.question.Qn.length === 0 || !this.question.S_Qn || this.question.S_Qn.length === 0) {
        this.addToast(true, false, false, false, false, false, false);
        if (!this.question.Qn || this.question.Qn.length === 0) {
          this.primaryLanguageQuestionEmpty = "redBottom";
        } else {
          this.primaryLanguageQuestionEmpty = "";
        }
        if (!this.question.S_Qn || this.question.S_Qn.length === 0) {
          this.secondaryLanguageQuestionEmpty = "redBottom";
        } else {
          this.secondaryLanguageQuestionEmpty = "";
        }
        return;
      } else {
        this.primaryLanguageQuestionEmpty = "";
        this.secondaryLanguageQuestionEmpty = "";
      }

      if (this.question.Qn_Disp_Value === 'Single Choice' || this.question.Qn_Disp_Value === 'Dropdown' || this.question.Qn_Disp_Value == 'Rank') {
        if (this.optionsSort.length < 2) {
          this.addToast(false, true, false, false, false, false, false);
          return;
        }

        let found: boolean = false;

        for (let i = 0; i < this.optionsSort.length; i++) {

          if (!this.optionsSort[i].primaryLanguage || this.optionsSort[i].primaryLanguage.length === 0) {
            this.optionsSort[i].primaryLanguageEmpty = "redBottom";
            found = true;
          } else {
            this.optionsSort[i].primaryLanguageEmpty = "";
          }

          if (!this.optionsSort[i].secondaryLanguage || this.optionsSort[i].secondaryLanguage.length === 0) {
            this.optionsSort[i].secondaryLanguageEmpty = "redBottom";
            found = true;
          } else {
            this.optionsSort[i].secondaryLanguageEmpty = "";
          }


        }

        if (found) {
          this.addToast(false, false, false, true, false, false, false);
          return;
        } else {
          this.question.Opt_Name.splice(0);
          this.question.S_Opt_Name.splice(0);

          for (let i = 0; i < this.optionsSort.length; i++) {
            this.question.Opt_Name.push(this.optionsSort[i].primaryLanguage);
            this.question.S_Opt_Name.push(this.optionsSort[i].secondaryLanguage);
          }


        }

      }

      if (this.question.Qn_Disp_Value === 'Multiple Choice') {
        if (this.optionsSort.length < 1) {
          this.addToast(false, false, true, false, false, false, false);
          return;
        }

        let found: boolean = false;

        for (let i = 0; i < this.optionsSort.length; i++) {

          if (!this.optionsSort[i].primaryLanguage || this.optionsSort[i].primaryLanguage.length === 0) {
            this.optionsSort[i].primaryLanguageEmpty = "redBottom";
            found = true;
          } else {
            this.optionsSort[i].primaryLanguageEmpty = "";
          }

          if (!this.optionsSort[i].secondaryLanguage || this.optionsSort[i].secondaryLanguage.length === 0) {
            this.optionsSort[i].secondaryLanguageEmpty = "redBottom";
            found = true;
          } else {
            this.optionsSort[i].secondaryLanguageEmpty = "";
          }


        }

        if (found) {
          this.addToast(false, false, false, true, false, false, false);
          return;
        } else {
          this.question.Opt_Name.splice(0);
          this.question.S_Opt_Name.splice(0);

          for (let i = 0; i < this.optionsSort.length; i++) {
            this.question.Opt_Name.push(this.optionsSort[i].primaryLanguage);
            this.question.S_Opt_Name.push(this.optionsSort[i].secondaryLanguage);
          }

        }

      }

      if (this.question.Parent_Dep && this.parentQuestion && this.question.Opt_Dep.length === <number>0) {
        this.addToast(false, false, false, false, true, false, false);
        this.noConditionSelected = "redColor";
        return;
      }

      this.dialogRef.close(this.question);

    } else {
      if (!this.question.Qn || this.question.Qn.length === 0) {
        this.addToast(true, false, false, false, false, false, false);
        this.primaryLanguageQuestionEmpty = "redBottom";
        return;
      } else {
        this.primaryLanguageQuestionEmpty = "";
      }

      if (this.question.Qn_Disp_Value === 'Single Choice' || this.question.Qn_Disp_Value === 'Dropdown') {
        if (this.optionsSort.length < 2) {
          this.addToast(false, true, false, false, false, false, false);
          return;
        }

        let found: boolean = false;

        for (let i = 0; i < this.optionsSort.length; i++) {

          if (!this.optionsSort[i].primaryLanguage || this.optionsSort[i].primaryLanguage.length === 0) {
            this.optionsSort[i].primaryLanguageEmpty = "redBottom";
            found = true;
          } else {
            this.optionsSort[i].primaryLanguageEmpty = "";
          }

        }

        if (found) {
          this.addToast(false, false, false, true, false, false, false);
          return;
        } else {
          this.question.Opt_Name.splice(0);

          for (let i = 0; i < this.optionsSort.length; i++) {
            this.question.Opt_Name.push(this.optionsSort[i].primaryLanguage);
          }

        }
      }

      if (this.question.Qn_Disp_Value === 'Multiple Choice' || this.question.Qn_Disp_Value === 'Rank' ) {
        if (this.optionsSort.length < 1) {
          this.addToast(false, true, false, false, false, false, false);
          return;
        }

        let found: boolean = false;

        for (let i = 0; i < this.optionsSort.length; i++) {

          if (!this.optionsSort[i].primaryLanguage || this.optionsSort[i].primaryLanguage.length === 0) {
            this.optionsSort[i].primaryLanguageEmpty = "redBottom";
            found = true;
          } else {
            this.optionsSort[i].primaryLanguageEmpty = "";
          }

        }

        if (found) {
          this.addToast(false, false, false, true, false, false, false);
          return;
        } else {
          this.question.Opt_Name.splice(0);

          for (let i = 0; i < this.optionsSort.length; i++) {
            this.question.Opt_Name.push(this.optionsSort[i].primaryLanguage);
          }

        }
      }


      if (this.question.Parent_Dep && this.parentQuestion && this.question.Opt_Dep.length === <number>0) {
        this.addToast(false, false, false, false, true, false, false);
        this.noConditionSelected = "redColor";
        return;
      }


      if (this.question.Qn_Disp_Value === 'Cascading Dropdown') {

        if (!this.sucessCascad) {

          this.addToast(false, false, false, false, false, false, true);
          return;
        }

      }

      this.dialogRef.close(this.question);
    }
  }

  close() {
    return null;
  }

  addToast(noQuestionStatement: boolean, lessThan2Options: boolean, lessThan1Options: boolean, optionInBothLanguage, condition: boolean, incorrectJSON: boolean, noJSON: boolean) {

    // Or create the instance of ToastOptions

    if (noQuestionStatement) {

      var toastOptions: ToastOptions = {
        title: "Empty Field",
        msg: "Question Statements in both languages are required",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    } else if (lessThan2Options) {

      var toastOptions: ToastOptions = {
        title: "Empty Field",
        msg: "At least 2 options are required",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    } else if (lessThan1Options) {

      var toastOptions: ToastOptions = {
        title: "Empty Field",
        msg: "At least 1 option is required",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    } else if (optionInBothLanguage) {

      var toastOptions: ToastOptions = {
        title: "Empty Field",
        msg: "Option Statements in both languages are required",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    } else if (condition) {

      var toastOptions: ToastOptions = {
        title: "Empty Field",
        msg: "Add Condition",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    } else if (incorrectJSON) {

      var toastOptions: ToastOptions = {
        title: "Incorrect File",
        msg: "Please submit file similar to Sample File.",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    } else if (noJSON) {

      var toastOptions: ToastOptions = {
        title: "No File Provided",
        msg: "Please provide the file for Cascading question",
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }
  }

  updateCondition(cond: number, opt: number) {
    this.noConditionSelected = "";
    this.question.Opt_Dep[cond] = opt;
  }

  addNewCondition() {
    const optionArray :number[] = this.question.Opt_Dep;
    if(optionArray && optionArray.length == 0){
      this.question.Opt_Dep.push(null);
      this.question.Opt_Dep.push(null);
    }
    else{
      this.question.Opt_Dep.push(null);
    }
  }

  removeCondition(i: number) {
    this.question.Opt_Dep.splice(i, 1);
  }

  fileUploaded(evt: any) {

    const scope = this;
    /* wire up file reader */
    const target: DataTransfer = (<DataTransfer>(evt.target));
    if (target.files.length != 1) {

      this.addToast(false, false, false, false, false, true, false);
      return;
    }
    const reader = new FileReader();
    reader.onload = function (e: any) {
      /* read workbook */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });


      /* grab first sheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const es = XLSX.utils.sheet_to_json(ws);


      /* save data to scope */
      scope.createJSON(<AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 })));
    };
    reader.readAsBinaryString(target.files[0]);
    this.fileName = target.files[0].name;
    this.question.Opt_Name.push(this.fileName);

    evt.target.value = "";


  }

  createJSON(data: AOA) {


    let numOfCols = 0;
    if (!isUndefined(data[0][0]) && data[0][0].length > 0) {
      numOfCols = 1;
    }
    if (!isUndefined(data[0][1]) && data[0][1].length > 0) {
      numOfCols = 2;
    }
    if (!isUndefined(data[0][2]) && data[0][2].length > 0) {
      numOfCols = 3;
    }
    if (!isUndefined(data[0][3]) && data[0][3].length > 0) {
      numOfCols = 4;
    }
    if (!isUndefined(data[0][4]) && data[0][4].length > 0) {
      numOfCols = 5;
    }

    if (numOfCols < 2) {
      this.addToast(false, false, false, false, false, true, false);
      return;
    }

    if (numOfCols > 5) {
      this.addToast(false, false, false, false, false, true, false);
      return;
    }


    let finalJSON = {};

    for (let i = 1; i < data.length; i++) {

      for (let j = 0; j < numOfCols; j++) {

        if (!isUndefined(data[i][j])) {
          if (j == 0) {
            if (finalJSON[data[i][j]] == null || isUndefined(finalJSON[data[i][j]])) {
              if (numOfCols > 2) {
                finalJSON[data[i][j]] = {};
              } else {
                finalJSON[data[i][j]] = [];
              }

            }
          }
          else if (j == 1) {
            if (j == numOfCols - 1) {
              finalJSON[data[i][j - 1]].push(data[i][j]);
            }
            else if (finalJSON[data[i][j - 1]][data[i][j]] == null || isUndefined(finalJSON[data[i][j - 1]][data[i][j]])) {
              if (j == numOfCols - 2) {
                finalJSON[data[i][j - 1]][data[i][j]] = []
              }
              else {
                finalJSON[data[i][j - 1]][data[i][j]] = {}
              }
            }
          }
          else if (j == 2) {
            if (j == numOfCols - 1) {
              finalJSON[data[i][j - 2]][data[i][j - 1]].push(data[i][j]);
            }
            else if (finalJSON[data[i][j - 2]][data[i][j - 1]][data[i][j]] == null || isUndefined(finalJSON[data[i][j - 2]][data[i][j - 1]][data[i][j]])) {
              if (j == numOfCols - 2) {
                finalJSON[data[i][j - 2]][data[i][j - 1]][data[i][j]] = [];
              }
              else {
                finalJSON[data[i][j - 2]][data[i][j - 1]][data[i][j]] = {};
              }
            }
          }
          else if (j == 3) {
            if (j == numOfCols - 1) {
              finalJSON[data[i][j - 3]][data[i][j - 2]][data[i][j - 1]].push(data[i][j]);
            }
            else if (finalJSON[data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]] == null || isUndefined(finalJSON[data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]])) {
              if (j == numOfCols - 2) {
                finalJSON[data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]] = []
              }
              else {
                finalJSON[data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]] = {}
              }

            }
          }
          else if (j == 4) {
            if (j == numOfCols - 1) {
              finalJSON[data[i][j - 4]][data[i][j - 3]][data[i][j - 2]][data[i][j - 1]].push(data[i][j]);
            }
            else if (finalJSON[data[i][j - 4]][data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]] == null || isUndefined(finalJSON[data[i][j - 4]][data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]])) {
              if (j == numOfCols - 2) {
                finalJSON[data[i][j - 4]][data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]] = []
              }
              else {
                finalJSON[data[i][j - 4]][data[i][j - 3]][data[i][j - 2]][data[i][j - 1]][data[i][j]] = {}
              }

            }
          }
          else if (j == 5) {
            if (j == numOfCols - 1) {
              finalJSON[data[i][j - 5]][data[i][j - 4]][data[i][j - 3]][data[i][j - 2]][data[i][j - 1]].push(data[i][j]);
            }
          }
        }
      }

    }

    this.sucessCascad = true;
    // console.log(JSON.stringify(finalJSON));
    this.cascadJSONService.setCascad(finalJSON);

  }


}

class OptionsSort {
  primaryLanguage: string = "";
  primaryLanguagePlaceholder: string = "";
  primaryLanguageEmpty: string = "";
  secondaryLanguage: string = "";
  secondaryLanguagePlaceholder: string = "";
  secondaryLanguageEmpty: string = "";
}

class NumberOptions {
  label: string;
  img: string;
}

class CalendarTypes {
  label: string;
  img: string;
}



// WEBPACK FOOTER //
// ./src/app/editQuestionDialog/edit-question-dialog.component.ts